import React from "react";
import { Activity, BarChart3, Target } from "lucide-react";
import { FOOTBALL_TABS } from "../constants/filters";

const TABS_CONFIG = [
  { id: FOOTBALL_TABS.FIXTURES, label: "Live Fixtures", icon: Activity },
  { id: FOOTBALL_TABS.STANDINGS, label: "League Tables", icon: BarChart3 },
  { id: FOOTBALL_TABS.PLAYERS, label: "Top Scorers", icon: Target }
];

const DesktopNavigation = ({ activeTab, onTabChange }) => {
  return (
    <div className="border border-white/10 rounded-sm p-4 bg-white/5">
      <div className="flex flex-wrap gap-2">
        {TABS_CONFIG.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`px-3 py-1.5 text-xs font-mono uppercase tracking-widest border transition-all duration-150 flex items-center gap-2 ${
                isActive
                  ? 'bg-white/10 text-white border-white/20'
                  : 'text-gray-500 border-white/10 hover:text-white hover:border-white/20'
              }`}
            >
              <span>{tab.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default DesktopNavigation;
